import { render, staticRenderFns } from "./portugalSeries.vue?vue&type=template&id=d61d6e1c&scoped=true"
import script from "./portugalSeries.vue?vue&type=script&lang=js"
export * from "./portugalSeries.vue?vue&type=script&lang=js"
import style0 from "./portugalSeries.vue?vue&type=style&index=0&id=d61d6e1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61d6e1c",
  null
  
)

export default component.exports